$(document).ready(function(){
  
  $(document).on('click', '.homepage_content .product_section .description', function(){
    $(this).addClass('showndiv');
  });
  
  var accessoryTickCounter = 0;
  
  var accessoryInterval = setInterval(function(){
    if ($('#w3-product-accessories .accessories-item').length > 0) {
      
      accessoryTickCounter++;
      if (accessoryTickCounter > 6) {
        
        clearInterval(accessoryInterval);
        
        if (!$('.product_name').text().match(/set$/)) {

          var head = $('#accessories-container-heading');
          $('#w3-product-accessories .accessories-item').first().after($(head).html());
          $('#w3-product-accessories > h3').text('Set items');
          $('#w3-product-accessories .accessories-item').first().find('input').remove();

        }
        
      }
      
      if ($('.product_name').text().match(/set$/)) {
        
        $('#accessories-container-heading h3').text('Set items');
        $('#w3-product-accessories .accessories-item input').each(function(k, elem){
          $(elem).remove();
        });
        
      }
      
    }
  }, 250);
  
});